import { Form, Formik } from 'formik';
import { useState } from 'react';

import FormField from '../../FormField';
import { updateUserPasswordSchema } from './schema/update-user-password-schema';

import Button from '@/components/ui/button';
import { IUpdateUserPayload } from '@/interfaces/api/user/IUpdateUserPayload';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

const initialValues = {
	newPassword: '',
	confirmPassword: '',
	password: '',
};

type PropTypes = {
	refetchUser: () => void;
};

const UpdateUserPasswordForm = ({ refetchUser }: PropTypes) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (
		values: IUpdateUserPayload,
		{ resetForm }: { resetForm: () => void },
	) => {
		try {
			await haggleApiService.updateUser(values);
			refetchUser();
			notificationService.success('User updated successfully');
			resetForm();
		} catch (error) {
			if (error instanceof Error) {
				notificationService.error(error.message);
			} else {
				notificationService.error(
					`Unknown error when trying to update the user: ${error}`,
				);
			}
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<div className="flex flex-col w-full p-4" data-test="update-password-form">
			<Formik
				initialValues={initialValues}
				onSubmit={(values, { resetForm }) =>
					handleSubmit(values, { resetForm })
				}
				validationSchema={updateUserPasswordSchema}
			>
				{() => (
					<Form className="flex flex-wrap gap-2 justify-between w-full">
						<div className="w-full">
							<FormField
								name="newPassword"
								label="New Password"
								type="password"
								placeholder="········"
							/>
						</div>
						<div className="w-full">
							<FormField
								name="confirmPassword"
								label="Confirm Password"
								type="password"
								placeholder="········"
							/>
						</div>
						<div className="w-full">
							<FormField
								name="password"
								label="Password"
								type="password"
								placeholder="········"
							/>
						</div>
						<div className="border w-full" />
						<Button
							type="submit"
							className="w-full my-2"
							shape="rounded"
							isLoading={isLoading}
							disabled={isLoading}
							data-test="submit-update-password-button"
						>
							Submit
						</Button>
					</Form>
				)}
			</Formik>
		</div>
	);
};
export default UpdateUserPasswordForm;
